import { combineReducers } from 'redux'
import summary from './summary/reducer'

export const reports = combineReducers({
	summary
})